import React from 'react';
import { GetEmailVerified } from '../../helpers/StorageEvents';
import { processContentfulConfig, validateConfig } from '../../helpers/pgDataLayerConfig';
import DOMPurify from 'isomorphic-dompurify';

const PgDataLayer = ({ pgdlConfig = null }) => {
    const config = processContentfulConfig(pgdlConfig);
    if (!config || !validateConfig(config)) {
        console.warn('No valid PG Data Layer configuration available');
        return null;
    }
    
    const PGDL = config;
    
    if ((typeof window !== 'undefined' && window.sessionStorage.getItem('isUserLoggedIn')) && GetEmailVerified()) {
        PGDL.user.type = 'member';
        PGDL.user.ID = window.sessionStorage.getItem(`${window.location.hostname}crmDetails`);
    }

    let PGDLObject;
    try {
        PGDLObject = JSON.stringify(PGDL, (key, value) => {
            if (typeof value === 'object' && value !== null) {
                if (cache.has(value)) {
                    return '[Circular]';
                }
                cache.add(value);
            }
            return value;
        });
        cache.clear();
    } catch (error) {
        console.error('Failed to stringify PG Data Layer:', error);
        return null;
    }

    const sanitizedScript = DOMPurify.sanitize(`var PGdataLayer = ${PGDLObject}`, {ALLOWED_TAGS: []});
    return (
        <script type="text/javascript" dangerouslySetInnerHTML={{ __html: sanitizedScript }} />
    );
};

const cache = new Set();

export default PgDataLayer;
